export default "__VITE_ASSET__0Mh1A5Kc__"